<template>
	<modal :exibir="exibir" :titulo="titulo" maxWidth="600" @close="fecharModal">
		<template #body>
			<az-form>
				<span :inner-html.prop="transformarCaractereEspecialEmEntidade(texto) | destacarPalavra(palavrasDestaque)"> </span>
			</az-form>
		</template>
	</modal>
</template>

<script>
import destacarPalavra from "@/views/credenciamento/detalhe-credenciamento/filters/destacar-palavra";
import Modal from "@/views/credenciamento/detalhe-credenciamento/commons/Modal.vue";

export default {
	name: 'modal-ver-mais',
	components: { Modal },
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		palavrasDestaque: {
			type: Array,
			default() {
				return []
			},
		},
		texto: {
			type: [String, Number],
			default: '---',
		},
		titulo: {
			type: String,
			default: '',
		},
	},
 methods: {
    destacarPalavra,
    transformarCaractereEspecialEmEntidade(valor) {
      return valor == null ? '' : String(valor)
    },
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
  filters: {
    destacarPalavra,
  },
}
</script>
